module.exports = __webpack_public_path__ + "static/template_olive_v2-8ab14c20d2483cf770c42896e4d28e4e.png";